import script from "./GuideCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideCTA.vue?vue&type=script&setup=true&lang=ts"

import "./GuideCTA.vue?vue&type=style&index=0&id=5971f78d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5971f78d"]])

export default __exports__